import { render, staticRenderFns } from "./DetailDelivery.vue?vue&type=template&id=1e564c56&scoped=true&"
import script from "./DetailDelivery.vue?vue&type=script&lang=js&"
export * from "./DetailDelivery.vue?vue&type=script&lang=js&"
import style0 from "./DetailDelivery.vue?vue&type=style&index=0&id=1e564c56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e564c56",
  null
  
)

export default component.exports